import { render, staticRenderFns } from "./DefectForm.vue?vue&type=template&id=614e62e8&"
import script from "./DefectForm.vue?vue&type=script&lang=js&"
export * from "./DefectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports